module.exports = __webpack_public_path__ + "static/media/nexus-logo.76c73021.svg";